import MobileChart from "./MobileChart";
export default MobileChart;